module.exports = __webpack_public_path__ + "img/t1-11.034eab37.png";